import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { ReportCertificate } from '../models/ReportCertificate';
import { Project } from '../../../common/certificates/models/valueObjects/Project';
import { Report } from '../../../common/certificates/models/valueObjects/Report';

export class ReportCertificateMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): ReportCertificate {
    const report = new Report(this.gqlIdEncoder.decode(data.report.id), data.report.name);
    const project = data.report.project ? new Project(this.gqlIdEncoder.decode(data.report.project.id), data.report.project.name) : null;

    return new ReportCertificate(this.gqlIdEncoder.decode(data.id), project, report);
  }
}
